import React, { FC } from 'react';

import { useIntl } from 'react-intl';

import { useCarouselRewards } from 'components/features/components/rewards-section/use-carousel-rewards';
import { RewardsCarousel } from 'components/rewards-carousel';
import { useLoyaltyRewardsList } from 'hooks/use-loyalty-rewards-list';

import { FeaturedRewardsContainer, Title } from './loyalty-featured-rewards.styled';

export const LoyaltyFeaturedRewards: FC = () => {
  const { formatMessage } = useIntl();
  const { featuredRewardsData, featuredRewardsLoading } = useLoyaltyRewardsList();

  const carouselRewards = useCarouselRewards({
    rewards: featuredRewardsData?.allRewardsSection?.[0]?.rewardsList || [],
  });

  if (featuredRewardsLoading || !carouselRewards?.length) {
    return null;
  }

  return (
    <FeaturedRewardsContainer>
      <Title>{formatMessage({ id: 'featured' })}</Title>
      <RewardsCarousel rewards={carouselRewards} />
    </FeaturedRewardsContainer>
  );
};
